import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { Inline } from "../Inline/Inline.mjs";
import { ActionsContext } from "./ActionsContext.mjs";
const actionsSpace = "xsmall";
const Actions = ({ size, data, children }) => {
  const contextValue = useMemo(() => ({ size }), [size]);
  return /* @__PURE__ */ jsx(ActionsContext.Provider, { value: contextValue, children: /* @__PURE__ */ jsx(Inline, { collapseBelow: "tablet", space: actionsSpace, data, children }) });
};
export {
  Actions
};
